<!-- @format -->

<template>
  <div>
    <div class="ui attached message">
      <div class="content">
        <div class="header">Lump Sum</div>
      </div>
    </div>
    <div class="ui attached segment">
      <div class="ui form fluid">
        <div class="ui field">
          <label>Lump Sum</label>
          <currency-input
            @change="handleChange"
            v-model.number="accounts[0].accountMarketValue"
            :currency="currency"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import vSelect from "vue-select";

import "vue-select/dist/vue-select.css";

export default {
  name: "IncomeInput",
  components: { vSelect },
  props: [
    "currency",
    "accounts",
    "contribution",
    "contributionFrequency",
    "contributionGrowth",
    "contributionGrowthFrequency",
    "contributionToLast",
    "contributionStartYear",
    "currentAge",
    "applyContribution",
  ],
  data() {
    return {
      contributionGrowthOptions: [
        { value: 1, text: "every year" },
        { value: 2, text: "every 2nd year" },
        { value: 3, text: "every 3rd year" },
        { value: 4, text: "every 4th year" },
        { value: 5, text: "every 5th year" },
        { value: 6, text: "every 6th year" },
        { value: 7, text: "every 7th year" },
        { value: 8, text: "every 8th year" },
        { value: 9, text: "every 9th year" },
        { value: 10, text: "every 10th year" },
      ],

      contributionPayoutFrequencies: [
        { value: 12, text: "per month" },
        { value: 3, text: "per quarter" },
        { value: 1, text: "per annum" },
      ],
    };
  },
  computed: {},
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else {
        return numeral(val).format("0,0.0a");
      }
    },
    discounted(val, years) {
      return val / Math.pow(1 + 0.055, years); // finlation adjusted
    },
    handleChange() {
      // construct withdrawal weights
      //let weights = [];

      this.$emit("handleInvestmentChanged", {
        accounts: this.accounts,
        applyContribution: this.applyContribution,
        contribution: this.contribution,
        contributionFrequency: this.contributionFrequency,
        currentAge: this.currentAge,
        contributionGrowth: this.contributionGrowth,
        contributionGrowthFrequency: this.contributionGrowthFrequency,
        contributionToLast: this.contributionToLast,
        contributionStartYear: this.contributionStartYear,

        // adhocCashFlow: this.adhocCashFlow
        //  public incomeGrowth: number = 0;
        // public incomeGrowthFrequency: number = 1; // every 1 yr, 2 year, ...
      });
    },
    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
